<template>
  <section class="e-feat" aria-labelledby="estrena2-features-title">
    <h2 id="estrena2-features-title" class="wd-title">
      <span class="hl">Características</span> <span class="e-feat__base">generales</span>
    </h2>

    <ul class="e-feat__grid">
      <li v-for="feature in features" :key="feature.title" class="e-feat__card">
        <div class="e-feat__head">
          <img :src="feature.icon" alt="" aria-hidden="true">
          <h3 class="e-feat__title">{{ feature.title }}</h3>
        </div>
        <p class="wd-body" v-html="feature.description" />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import homeIcon from '../../../assets/estrena2-figma/ic-home.svg'
import agentIcon from '../../../assets/estrena2-figma/ic-agent.svg'
import paymentsIcon from '../../../assets/estrena2-figma/ic-payments.svg'
import folderIcon from '../../../assets/estrena2-figma/ic-folder.svg'
import gymnasticsIcon from '../../../assets/estrena2-figma/ic-gymnastics.svg'

const features = [
  { icon: homeIcon, title: 'Tipo de vivienda', description: 'Vivienda de uso' },
  { icon: agentIcon, title: 'Comprador', description: 'Persona física' },
  { icon: paymentsIcon, title: 'Validación financiera', description: 'Revisión de capacidad de <br class="br-d">pago' },
  { icon: folderIcon, title: 'Expediente', description: 'Integración documental obligatoria' },
  { icon: gymnasticsIcon, title: 'Flexibilidad inicial', description: 'Posibilidad de un periodo previo antes de pagos completos' }
]
</script>

<style scoped>
.e-feat { display: flex; flex-direction: column; gap: var(--ds-space-7); }
.e-feat__base { color: var(--ds-purple-900); }

.e-feat__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--ds-space-5);
  margin: 0;
  padding: 0;
  list-style: none;
}

.e-feat__card {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
  /* El borde de 1px va dentro de las medidas del Figma (24px de padding incluyendo el trazo) */
  padding: calc(var(--ds-space-5) - 1px);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border: 1px solid var(--ds-border-card);
  border-radius: 16px;
}

.e-feat__head { display: flex; align-items: center; gap: var(--ds-space-4); }
.e-feat__head img { flex: 0 0 40px; width: 40px; height: 40px; }
.e-feat__title {
  margin: 0;
  color: var(--ds-text-body);
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
}

@media (max-width: 1024px) {
  .e-feat__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 599px) {
  .e-feat { gap: var(--ds-space-6); }
  .e-feat__grid { grid-template-columns: minmax(0, 1fr); }
}
</style>
